'use strict'

pageHeaderTemplate = require '../../title.html.mustache'

module.exports = Backbone.View.extend

  render: (pageHeaderTitleHash) ->
    return unless pageHeaderTitleHash?.headerTitle

    searchQuery = pageHeaderTitleHash.headerTitle.searchQuery

    if searchQuery
      @$el.find('.search-query').text(searchQuery)
    else
      @$el.html(pageHeaderTemplate.render(pageHeaderTitleHash))

